import React,{useState,useEffect} from 'react';
import './DailyTaskUpdate.css';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { useMsal } from "@azure/msal-react";
import {getProjectMasterList} from "../function-components/Redux/ProjectMasterSlice";
import {Radio, RadioGroup, FormLabel, FormControlLabel, Input,InputLabel, Autocomplete} from '@mui/material';

const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
// const baseURL = "http://localhost:1101";
const DailyTaskUpdate = () => {
const projectData = useSelector((state) => state.projectMaster.projectMasterList);
const [project, setProject] = useState('');
const [requestType, setRequestType] = useState('New');
const [status, setStatus] = useState('select');
const [otherTaskType, setOtherTaskType] = useState('select');
const [selectedTeam, setSelectedTeam] = useState('');
const [selectedTaskType, setSelectedTaskType] = useState('');
const [selectedSubTask, setSelectedSubTask] = useState('');
const [startDate, setStartDate] = useState(null);
const [endDate, setEndDate] = useState(null);
const [description, setDescription] = useState('');
const [addProjectResult, setAddProjectResult] = useState('');
const [effort, setEffort] = useState('');
const [username, setUsername] = useState(null);
const uniqueProjectNames = [...new Set(projectData.map((project) => project.name))];

let filteredNewProjects = []
let filteredCRProjects = []
for(let project of projectData) {        
  project.request_type === 'new' && filteredNewProjects.push(project.name+' ('+project.request_id+')');
  project.request_type === 'change request' && filteredCRProjects.push(project.name+' ('+project.request_id+'-'+project.category+')');
}

const [filteredProjects, setFilteredProjects] = useState(uniqueProjectNames);
const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
const dispatch = useDispatch();
const theme = createTheme({
        typography: {
        fontFamily: "Graphik-Regular",
       },
       });

useEffect(() => {   
  dispatch(getProjectMasterList("all"));
}, []);

useEffect(() => {
  if (activeAccount) {
    setUsername(activeAccount.idTokenClaims.enterpriseID);
  } else {
    setUsername(null);
  }
 }, [activeAccount]);


// const filteredProjects = projectData.filter(project => ['4', '1', '2'].includes(project.status));
// const uniqueProjectNames = [...new Set(filteredProjects.map((project) => project.name))];

// const changeRequestFilteredProjects = projectData.filter(project => ['3'].includes(project.status));
// const changeReqUniqueFilteredProject = [...new Set(changeRequestFilteredProjects.map((project) => project.name))];

const handleTeamChange = (event) => {
        setSelectedTeam(event.target.value);
        setSelectedTaskType('');
        setSelectedSubTask('');
      };
    
const handleTaskTypeChange = (event) => {
        setSelectedTaskType(event.target.value);
        setSelectedSubTask('');
      };

const handleRequestTypeChange = (event) => {
const newRequestType = event.target.value;
if( (requestType === 'New' && newRequestType === 'Change') ||
(requestType === 'Change' && newRequestType === 'New') || (requestType === 'New' && newRequestType === 'Others') ||
(requestType === 'Others' && newRequestType === 'New') ||  (requestType === 'Change' && newRequestType === 'Others') || 
(requestType === 'Others' && newRequestType === 'Change')) {
  setSelectedTaskType('');
  setSelectedSubTask('');
  setSelectedTeam('');
  setEffort('');
  setStartDate(null);
  setEndDate(null);
  setDescription('');
  setStatus('select');
  setProject('');
}
  setRequestType(newRequestType);
};

const teams = ['Dev Team', 'Infra Team', 'Design Team', 'Power BI Team'];
const taskTypes = {
         'Design Team': {
          New : ['Home Page Creation', 'Wireframe Creation', 'Infrographics Creation', 'Banner Development (identifying images and customizing the bannners)',
          'Portal Design Review', 'Accessibility Review and Fixing'],
          Change : ['Banner Change', 'Icons/Images', 'Infographics', 'Revamping Existing Design'],
         },
         'Dev Team': {
          New : ['Updating the Requirements Document', 'Initial Code Setup', 'Home Page Development','DB Set up','Node Code Development in Local',
          'Other Pages Development','BOT integration and testing','Dashboard or Leaderboard via coding','Updating review document',
          'Accessibility code review and fixing','Stakeholders review and correction','Portal Design  Review (peer Review or by lead)',
          'Portal Dev Review (by peers or leads)','Additional or New Requirements'],
          Change : ['Content Update', 'UI Corrections', 'Additional or New Requirements','DB change',
          'Node Code change','BOT service update'],
         },
         'Infra Team': {
          New: ['Repo Creation', 'DNS', 'SSL Request', 'DNS/SSL Configuration with Nginx for First Time Deployment',
          'ESO Request and testing (staging and Production)', 'DB schema creation','Node code deployment','Updating project documents (node, DB, ESO, Deployment commands)',
          'Jenkins pipeline creation','Updating infra documents (server status, portals deployed, repo created)','Creating Azure Bot service in cloud'],
          Change: ['Infra Changes'],
        },
         'Power BI Team': {
          New: ['Reports Design', 'Reports Creation'],
          Change: ['Power BI Changes','Power App Changes']
         }
       };
       
       const subTasks = {
        'Dev Team': {
          'Updating the Requirements Document': [],
          'Initial Code Setup': ['Pushing Code to Repo', 'ESO Integration with Staging', 'ESO Integration with Production', 'Header & Footer Setup'],
          'Home Page Development': ['Homepage Components - About Us Section with Video', 'Homepage Testimonial Section', 'Homepage - Leadership Video or Message', 'Homepage Infographics'],
          'DB Set up': ['DB Schema Creation and Testing in Local', 'DB Testing with DB Server'],
          'Node Code Development in Local': ['Node Code Development and Testing in Local', 'Node Code Connection Testing in Server'],
          'Other Pages Development': ['FAQ Page', 'Meet the Team Page', 'Testimonial Page'],
          'BOT integration and testing': [],
          'Dashboard or Leaderboard via coding': [],
          'Updating review document': [],
          'Accessibility code review and fixing': [],
          'Stakeholders review and correction': [],
          'Portal Design  Review (peer Review or by lead)': [],
          'Portal Dev Review (by peers or leads)': [],
          'Content Update': [],
          'UI Corrections': ['Image, Banner Replacement', 'Font Space Corrections', 'Adding New UI Component'],
          'Additional or New Requirements': ['Adding New Page', 'Adding Automation', 'Adding New Logic to Existing'],
          'DB change': [],
          'Node Code change': [],
          'BOT service update': [],
        },
        'Infra Team': [],
        'Design Team': [],
        'Power BI Team': [],
      };

const handleSubmit = () => {
  if (requestType === 'New' || requestType === 'Change') {
  if (project === '' || selectedTeam === '' || selectedTaskType === '' || startDate === null || status === 'select' || effort === '' || description === '') {
    setAddProjectResult('invalidate');
    setTimeout(() => {
      setAddProjectResult('');
    }, 3000)
    return;
  }
} else if (requestType === 'Others') {
  if ( otherTaskType === 'select' || selectedTeam === '' || selectedTaskType === '' || startDate === null || status === 'select' || effort === '' || description === '') {
    setAddProjectResult('invalidate');
    setTimeout(() => {
      setAddProjectResult('');
    }, 3000)
    return;
  }
}
  let projectArr = project.split(' ');
  let popedElement = projectArr.pop();
  axios.post(`${baseURL}/addNewDailyTaskUpdate/${username}`,{
    "projectName": project === '' ? '' : projectArr.join(' '),
    "requestType": requestType,
    "team": selectedTeam,
    "status": status,
    "taskType": selectedTaskType,
    "subTask": selectedSubTask,
    "startDate": startDate === null ? "0000-00-00" : startDate.format("YYYY-MM-DD"),
    "endDate": endDate === null ? "0000-00-00" : endDate.format("YYYY-MM-DD"),
    "effort": effort,
    "description": description,
    "otherTaskType": otherTaskType,
    "category": requestType === 'New' ? popedElement.slice(1,-1).split('_')[0] : requestType === 'Change' ? popedElement.slice(1,-1).split('-')[1] : null     
  })
  .then(res => {
    console.log(res);
    setAddProjectResult('ok')
    setTimeout(() => {
      setAddProjectResult('');
    }, 3000)
    handleReset();
  })
  .catch(err => {
    setAddProjectResult("failed")
    setTimeout(() => {
      setAddProjectResult('');
    }, 3000)
  })
}
       
const handleReset = () =>  {
  if (requestType === 'New' || requestType === 'Change') {
  setProject('');
  setSelectedTeam('');
  setStatus('select');
  setSelectedTaskType('');
  setSelectedSubTask('');
  setStartDate(null);
  setEndDate(null);
  setEffort('');
  setDescription('')
} else  {
  setOtherTaskType('select');
  setSelectedTeam('');
  setStatus('select');
  setSelectedTaskType('');
  setStartDate(null);
  setEndDate(null);
  setEffort('');
  setDescription('')
}
}
    return (
        <>
        <ThemeProvider theme={theme} >
        <Box style={{backgroundColor:"#F8F5FA" }}>
        <Box sx={{width:"93.5%",margin:"auto", paddingTop:"70px", paddingBottom: "72px"}}>
        <Box className='main_section'>
        <Typography className="headerText"sx={{}}>Daily Task Update</Typography>
        <FormControl component="fieldset">
        {/* <FormLabel component="legend">Request Type</FormLabel> */}
        <div className="radio_button_section"> 
        <RadioGroup
          aria-label="requestType"
          name="requestType"
          value={requestType}
          onChange={handleRequestTypeChange}
        >
          <FormControlLabel value="New" control={<Radio />} label="New" />
          <FormControlLabel value="Change" control={<Radio />} label="Change Request" />
          <FormControlLabel value="Others" control={<Radio />} label="Others" />
        </RadioGroup>
        </div>
      </FormControl>
      {requestType === "New" || requestType === "Change" ? 
        <Box>
        <Stack className="firstSection_dailyTask">    
        <div className="date_section" style={{ width: '40%' }}>
        <label className="form_label" for="selectProjectName">
        Select project name<span className="add-project--asterisk">*</span>
        </label> 
      <FormControl sx={{ m: 1, minWidth: 120 }}>                
        <Autocomplete
          disablePortal
          id="selectProjectName"          
          options={requestType === "New" ? filteredNewProjects : filteredCRProjects}          
          value={project}                    
          onChange={(event, newValue) => setProject(newValue || '')}                    
          renderInput={(params) => <TextField {...params} label="Search projects..." />}
        />
      </FormControl>      
      </div>
        <div className="date_section" style={{width: "30%"}}>
        <label className="form_label" for="selectTeam">
        Select team<span className="add-project--asterisk">*</span>
        </label> 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                value={selectedTeam} 
                onChange={handleTeamChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="">
                <em>Select</em>
              </MenuItem>
              {teams.map((team) => (
            <MenuItem key={team} value={team}>
              {team}
            </MenuItem>
          ))}
            </Select>
            </FormControl>
        </div>
        {/* <div className="date_section" style={{width: "22%"}}>
        <label className="form_label" for="requestType">
        Request type<span className="add-project--asterisk">*</span>
        </label> 
        {selectedTeam === 'Dev Team' || selectedTeam === 'Design Team' ? 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                  value={requestType}
                  onChange={handleRequestTypeChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="select">
                <em>Select</em>
              </MenuItem>
            <MenuItem value={1}>New </MenuItem>
            <MenuItem value={2}>Change Request</MenuItem>
            <MenuItem value={3}>Others</MenuItem>
            </Select>
            </FormControl>
            :
            <FormControl sx={{ m: 1, minWidth: 120 }}>
            <Select
             value={requestType}
             onChange={(e) => setRequestType(e.target.value)}
           displayEmpty
           inputProps={{ 'aria-label': 'Without label' }}
             >
           <MenuItem value="select">
           <em>Select</em>
         </MenuItem>
       <MenuItem value={1}>New </MenuItem>
       <MenuItem value={3}>Others</MenuItem>
       </Select>
       </FormControl>
        }
        </div> */}
        <div className="date_section" style={{width: "30%"}}>
        <label className="form_label" for="selectStatus">
        Select status<span className="add-project--asterisk">*</span>
        </label> 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="select">
                <em>Select</em>
              </MenuItem>
            <MenuItem value={1}>Yet to Start </MenuItem>
            <MenuItem value={2}>In Progress</MenuItem>
            <MenuItem value={3}>Completed</MenuItem>
            <MenuItem value={4}>New</MenuItem>
            </Select>
            </FormControl>
        </div>
        </Stack>
        <Stack className="firstSection_dailyTask">
        <div className="date_section" style={{width: "35.5%"}}>
        <label className="form_label" for="taskName">
        Task type<span className="add-project--asterisk">*</span>
        </label> 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                value={selectedTaskType} 
                onChange={handleTaskTypeChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="">
                <em>Select</em>
              </MenuItem>
              {taskTypes[selectedTeam] &&
            taskTypes[selectedTeam][requestType] &&
            taskTypes[selectedTeam][requestType].map((taskType) => (
              <MenuItem key={taskType} value={taskType}>
                {taskType}
              </MenuItem>
            ))}
            </Select>
            </FormControl>
        </div>
        <div className="date_section" style={{width: "31.5%"}}>
        <label className="form_label" for="subTask">
        Sub task
        </label> 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
        <Select value={selectedSubTask} onChange={(event) => setSelectedSubTask(event.target.value)}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}>
        <MenuItem value="">
                <em>Select</em>
              </MenuItem>
            {subTasks[selectedTeam] &&
            subTasks[selectedTeam][selectedTaskType] &&
            subTasks[selectedTeam][selectedTaskType].map((subTask) => (
              <MenuItem key={subTask} value={subTask}>
                {subTask}
              </MenuItem>
            ))}
            </Select>
            </FormControl>
          </div>
          <div className="date_section" style={{width: "15.5%"}}>
          <label className="form_label" for="selectProjectName">
          Start date<span className="add-project--asterisk">*</span>
          </label> 
         <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker 
                  value={startDate}
                  onChange={(date) => setStartDate(date)}
                 inputFormat="DD/MM/YYYY"
                 //minDate={dayjs(row.startDate, "DD/MM/YYYY").add(1, 'day')}
                />
        </LocalizationProvider>
        {/* <DatePicker value={startDate}  onChange={(newValue) => setStartDate(newValue)} render={<InputIcon/>}  />  */}
        </div>
        <div className="date_section" style={{width: "17.5%"}}>
        <label className="form_label" for="selectStatus">
        End date
        </label> 
        <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker 
                  value={endDate}
                  onChange={(date) => setEndDate(date)}
                 inputFormat="DD/MM/YYYY"
                 //minDate={dayjs(row.startDate, "DD/MM/YYYY").add(1, 'day')}
                />
        </LocalizationProvider>
         {/* <DatePicker value={endDate}  onChange={(newValue) => setEndDate(newValue)} render={<InputIcon/>}  />  */}
        </div>
        </Stack>
        <Stack className="firstSection_dailyTask">
        <div className="date_section" style={{width: "20%"}}>
        <label className="form_label" for="selectProjectName">
        Effort (in hr)<span className="add-project--asterisk">*</span>
        </label> 
        <TextField
         fullWidth
         multiline
         variant="outlined"
         value={effort}
         onChange={(e) => setEffort(e.target.value.replace(/[^0-9.]/g, ''))}
         inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*'
        }}
        />
        </div>
        <div className="date_section" style={{width: "80%"}}>
        <label className="form_label" for="selectStatus">
        Description<span className="add-project--asterisk">*</span>
        </label> 
       <TextField
       fullWidth
       multiline
       variant="outlined"
       rows={5}
       value={description}
       onChange={(e) => setDescription(e.target.value)}
       />
        </div>
        </Stack>
        </Box> 
        :
        <Box>
          <Stack className="firstSection_dailyTask">
          <div className="date_section" style={{width: "23%"}}>
        <label className="form_label" for="selectTeam">
        Select task<span className="add-project--asterisk">*</span>
        </label> 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                value={otherTaskType}
                onChange={(e) => setOtherTaskType(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="select">
                <em>Select</em>
              </MenuItem>
            <MenuItem value={"Issues fixing or incident"}>Issues fixing or incident</MenuItem>
            <MenuItem value={"R & D work"}>R & D work</MenuItem>
            <MenuItem value={"POC Creation for the R&D"}>POC Creation for the R&D</MenuItem>
            <MenuItem value={"Automation"}>Automation</MenuItem>
            <MenuItem value={"Process Enhancement"}>Process Enhancement</MenuItem>
            <MenuItem value={"Attending Training Sessions & Courses"}>Attending Training Sessions & Courses</MenuItem>
            <MenuItem value={"Vulnerabilities on Application"}>Vulnerabilities on Application</MenuItem>
            <MenuItem value={"Vulnerabilities on Servers"}>Vulnerabilities on Servers</MenuItem>
            <MenuItem value={"Vulnerabiliites on Azure Account"}>Vulnerabiliites on Azure Account</MenuItem>
            <MenuItem value={"Others"}>Others</MenuItem>
            </Select>
            </FormControl>
        </div>


          <div className="date_section" style={{width: "23%"}}>
        <label className="form_label" for="selectTeam">
        Select team<span className="add-project--asterisk">*</span>
        </label> 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                value={selectedTeam} 
                onChange={handleTeamChange}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="">
                <em>Select</em>
              </MenuItem>
              {teams.map((team) => (
            <MenuItem key={team} value={team}>
              {team}
            </MenuItem>
          ))}
            </Select>
            </FormControl>
        </div>
        <div className="date_section" style={{width: "23%"}}>
        <label className="form_label" for="selectStatus">
        Select status<span className="add-project--asterisk">*</span>
        </label> 
        <FormControl sx={{ m: 1, minWidth: 120 }}>
                 <Select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                  >
                <MenuItem value="select">
                <em>Select</em>
              </MenuItem>
            <MenuItem value={1}>Yet to Start </MenuItem>
            <MenuItem value={2}>In Progress</MenuItem>
            <MenuItem value={3}>Completed</MenuItem>
            <MenuItem value={4}>New</MenuItem>
            </Select>
            </FormControl>
        </div>
        <div className="date_section" style={{width: "30%"}}>
        <label className="form_label" for="taskName">
        Task name<span className="add-project--asterisk">*</span>
        </label> 
        <TextField
         fullWidth
         multiline
         variant="outlined"
         value={selectedTaskType} 
         onChange={handleTaskTypeChange}
         />
        </div>
          </Stack>
          <Stack className="firstSection_dailyTask">
          <div className="date_section" style={{width: "16.5%"}}>
        <label className="form_label" for="selectProjectName">
        Effort (in hr)<span className="add-project--asterisk">*</span>
        </label> 
        <TextField
         fullWidth
         multiline
         variant="outlined"
         value={effort}
          onChange={(e) => setEffort(e.target.value.replace(/[^0-9.]/g, ''))}
          type="number"
          step="0.1"
        />
        </div>
          <div className="date_section" style={{width: "16.5%"}}>
          <label className="form_label" for="selectProjectName">
          Start date<span className="add-project--asterisk">*</span>
          </label> 
         <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker 
                  value={startDate}
                  onChange={(date) => setStartDate(date)}
                 inputFormat="DD/MM/YYYY"
                 //minDate={dayjs(row.startDate, "DD/MM/YYYY").add(1, 'day')}
                />
        </LocalizationProvider>
        </div>
        <div className="date_section" style={{width: "16.5%"}}>
        <label className="form_label" for="selectStatus">
        End date
        </label> 
        <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker 
                  value={endDate}
                  onChange={(date) => setEndDate(date)}
                 inputFormat="DD/MM/YYYY"
                 //minDate={dayjs(row.startDate, "DD/MM/YYYY").add(1, 'day')}
                />
        </LocalizationProvider>
        </div>
        <div className="date_section" style={{width: "50%"}}>
        <label className="form_label" for="selectStatus">
        Description<span className="add-project--asterisk">*</span>
        </label> 
       <TextField
       fullWidth
       multiline
       variant="outlined"
       rows={5}
       value={description}
       onChange={(e) => setDescription(e.target.value)}
       />
        </div>
          </Stack>
        </Box>
      }
        <Stack className='dailyTaskUpdate_buttonSection'>
         <Button className="active_button_section" onClick={handleSubmit}>
            Submit
         </Button>
         <Button className="inactive_button_section" onClick={handleReset}>
            Cancel
         </Button>
         {addProjectResult === 'ok' && <span className="add-project--success">Details added Successfully.</span>}
         {addProjectResult === 'failed' && <span className="add-project--failed">Failed to add details!</span>}
         {addProjectResult === 'invalidate' && <span className="add-project--invalidate">All fields marked with an asterisk (*) are required.</span>} 
        </Stack>
        </Box>
        </Box>
        </Box>
        </ThemeProvider>
        </>
    )
}

export default DailyTaskUpdate;